import React from 'react';

import { PortfolioCovenantEditContainer } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/portfolioCovenant/PortfolioCovenantEditContainer';
import { BorrowingBaseMechanics } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/BorrowingBaseMechanics';
import { PortfolioCovenants } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/section/PortfolioCovenants';
import {
  CreditAgreement,
  CreditAgreementFullArtifactWipConfigType,
} from 'packages/creditAgreements/ui/types';

export const CreditAgreementFullArtifactSection: React.FC<{
  creditAgreementFullArtifact: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  section: keyof CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  isEditOnlyMode: boolean;
  wipConfig?: CreditAgreementFullArtifactWipConfigType;
}> = ({ creditAgreementFullArtifact, section, isEditOnlyMode, wipConfig }) => {
  const {
    borrowingBaseMechanics,
    portfolioCovenants,
    creditFacilityId,
  } = creditAgreementFullArtifact;

  // add more section from the CreditAgreementFullArtifact cases as we introduce more individually editable sections
  switch (section) {
    case 'borrowingBaseMechanics':
      return (
        <BorrowingBaseMechanics
          borrowingBaseMechanics={borrowingBaseMechanics}
          creditFacilityId={creditFacilityId}
          wipConfig={wipConfig}
        />
      );
    case 'portfolioCovenants':
      if (isEditOnlyMode && wipConfig) {
        return (
          <PortfolioCovenantEditContainer
            creditFacilityId={creditFacilityId}
            wipConfig={wipConfig}
          />
        );
      }
      return (
        <PortfolioCovenants
          portfolioCovenants={portfolioCovenants}
          wipConfig={wipConfig}
        />
      );
    default:
      return null;
  }
};
